import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import PropTypes from 'prop-types';
import { handleRipple } from '../../../../helpers/ripple';
import {
  IconButton,
  LockScroll,
  NavbarSection,
  NavbarList,
  NavbarLink,
  SubNavbarLink,
  LoginButton,
  BitcoinLogo,
} from './styled';

const Menu = ({ isOpen, onClick }) => {
  const handleButtonClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  const navbarList = [
    {
      key: 'news',
      text: 'News',
      link: 'https://news.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'wallet',
      text: 'Wallet',
      link: 'https://wallet.bitcoin.com/',
      openNewTab: true,
      submenu: [
        { key: 'bitcoin-wallet', text: 'Bitcoin Wallet', link: 'https://wallet.bitcoin.com/bitcoin/', openNewTab: false },
        { key: 'bitcoin-cash-wallet', text: 'Bitcoin Cash', link: 'https://wallet.bitcoin.com/bitcoin-cash/', openNewTab: false },
        { key: 'usdt-wallet', text: 'USDT Wallet', link: 'https://wallet.bitcoin.com/tether/', openNewTab: false },
        { key: 'usdc-wallet', text: 'USDC Wallet', link: 'https://wallet.bitcoin.com/usd-coin/', openNewTab: false },
        { key: 'polygon-wallet', text: 'Polygon Wallet', link: 'https://wallet.bitcoin.com/polygon/', openNewTab: false },
        { key: 'bnb-wallet', text: 'BNB Wallet', link: 'https://wallet.bitcoin.com/bnb/', openNewTab: false },
        { key: 'verse-wallet', text: 'Verse Wallet', link: 'https://wallet.bitcoin.com/verse/', openNewTab: false },
      ],
    },
    {
      key: 'games',
      text: 'Games',
      link: 'https://games.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'buy',
      text: 'Buy',
      link: 'https://buy.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'learn',
      text: 'Learn',
      link: 'https://www.bitcoin.com/get-started/',
      openNewTab: false,
    },
    {
      key: 'research',
      text: 'Research',
      link: 'https://www.bitcoin.com/research/',
      openNewTab: false,
    },
    {
      key: 'offers',
      text: 'Offers',
      link: 'https://www.bitcoin.com/directory/',
      openNewTab: false,
    },
  ];

  const buttonData = {
    buttonText: 'Get Bitcoin',
    buttonLink: 'https://branch.wallet.bitcoin.com/KE0EQAPrqAb',
  };

  return (
    <>
      <IconButton onClick={handleButtonClick}>
        {isOpen ? (
          <IoMdClose size={40} color="#1c1c1c" />
        ) : (
          <GiHamburgerMenu size={40} color="#1c1c1c" />
        )}
      </IconButton>
      <LockScroll locked={isOpen} />
      <NavbarSection open={isOpen}>
        <NavbarList>
          {navbarList.map(item => (
            <React.Fragment key={item.key}>
              <NavbarLink
                href={item.link}
                target={item.openNewTab ? '_blank' : undefined}
                rel={item.openNewTab ? 'noopener noreferrer' : undefined}
              >
                {item.text}
              </NavbarLink>
              {item.submenu && item.submenu.map(sub => (
                <SubNavbarLink
                  key={sub.key}
                  href={sub.link}
                  target={sub.openNewTab ? '_blank' : undefined}
                >
                  {sub.text}
                </SubNavbarLink>
              ))}
            </React.Fragment>
          ))}
        </NavbarList>
        <LoginButton
          href={buttonData.buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={handleRipple}
        >
          <BitcoinLogo
            src="/images/uploads/home/floating-button-icon.png"
            alt="bitcoin logo"
          />
          {buttonData.buttonText}
        </LoginButton>
      </NavbarSection>
    </>
  );
};

Menu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Menu;
